import gsap from "gsap";
import "./link";

promokit.page({
    caution: '#section-caution',
    cnb: true, //true, false
    topButton: true, //true, false
    footer: {
        fixed: true,
        theme: 'white' //'black', 'white'
    },
    headerButton: {
        el: '.header-button',
        cookie: {
            type: 'year', //'year', 'week', 'day'
            key: 'INDEX_WEB_VISIT_210203_index',
            value: false
        },
        home: true,
        event: true,
        sns: true,
        theme: 'black' //'black', 'white'
    }
});

const indexAnimation = gsap.timeline({paused:true})
    .from($(".p-header__bg--2"), 1.2, {y:125, autoAlpha:0, ease:"Elastic.easeOut"}, "+=0.5")
    .from($(".p-header__bg--4"), 1.2, {y:125, autoAlpha:0, ease:"Elastic.easeOut"}, "-=0.98")
    .from($(".p-header__bg--5"), 1.2, {y:125, autoAlpha:0, ease:"Elastic.easeOut"}, "-=0.98")
    .from($(".p-header__bg--6"), 1.2, {y:125, autoAlpha:0, ease:"Elastic.easeOut"}, "-=0.98")
    .addLabel("treeEnd", "-=0.98")
    .from($(".p-header__bg--7"), 1.2, {y:125, autoAlpha:0, ease:"Elastic.easeOut"}, "treeEnd")
    .add(function(){$(".p-header__cloud--wrap").addClass("p-header__cloud--active");}, "treeEnd-=0.0")
    .from($(".characters--3"), 1.0, {y:65, scale:0.6, autoAlpha:0, ease:"Elastic.easeOut"}, "-=1.0")
    .from($(".characters--2"), 1.0, {y:65, scale:0.6, autoAlpha:0, ease:"Elastic.easeOut"}, "-=0.89")
    .from($(".characters--4"), 1.0, {y:65, scale:0.6, autoAlpha:0, ease:"Elastic.easeOut"}, "-=1.0")
    .from($(".characters--1"), 1.0, {y:65, scale:0.6, autoAlpha:0, ease:"Elastic.easeOut"}, "-=0.89")
    .from($(".characters--5"), 1.0, {y:65, scale:0.6, autoAlpha:0, ease:"Elastic.easeOut"}, "-=1.0")
    .from($(".p-header__tit"), 1.4, {y:70, autoAlpha:0, ease:"Elastic.easeOut"}, "-=0.62")
    .from($(".etc-menu"), 0.8, {y:80, autoAlpha:0, ease:"Power2.easeOut"}, "-=1.0")
    .from($(".other-menu"), 0.8, {y:80, autoAlpha:0, ease:"Power2.easeOut"}, "-=0.72");

promokit.preload({
    complete: function() {
        indexAnimation.play();
    }
});


// WEBPACK FOOTER //
// ./src/js/index.js